<template>
<div class="search">
        <input type="text" v-model="search" :placeholder="$store.state.page">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.966 56.966" class="search__image"><path d="M55.146 51.887L41.588 37.786A22.926 22.926 0 0 0 46.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 0 0 .083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z" data-original="#000000" class="active-path" data-old_color="#222121" fill="#1F1F1F"/></svg>
</div>
</template>

<script>
  export default {
    data() {
        return {
        }
    },
    computed: {
        search: {
            get() {
                return this.$store.state.search
            },
            set(searchWord) {
                this.$store.commit('searchUpdate', searchWord)
            }
        }
    },
    methods: {
        show(){
            console.log(this.$store.state.search)
        }
    },

}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
  .search {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 20px;

    &__image {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 25px;
      width: 20px;
      height: 20px;
      pointer-events: none;

      path {
        fill: #757575;
        transition: fill 200ms;

        .dark & {
          fill: $dark-text;
        }
      }

    }

    input:focus + .search__image path {
      fill: #3d3df3;
    }

    input {
      position: relative;
      height: 30px;
      width: 130px;
      padding: 0 25px 0 5px;
      border: 2px solid transparent;
      border-radius: 4px;
      background-color: #f2f2f3;
      font-weight: 600;
      font-size: 13px;
      outline: none;
      transition: width 200ms;

      &:focus {
        width: 200px;
        border: 2px solid #f2f2f3;
        background-color: transparent;

        .dark & {
          border: 2px solid #313131;
        }
      }

      &::placeholder {
        color: #757575;
      }

      .dark & {
        background-color: $bg-grey;
        color: $dark-text;

        &::placeholder {
          color: $dark-text;
        }
      }
    }
  }
</style>
